var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71412 23.0792C4.71412 20.4343 4.73296 17.7893 4.70118 15.1444C4.69294 14.4841 4.9413 14.1144 5.49924 13.7943C10.1358 11.1399 14.7606 8.46675 19.3807 5.78533C19.8257 5.52754 20.1917 5.5299 20.6331 5.7865C25.2544 8.46675 29.878 11.1411 34.5146 13.7931C35.0784 14.1156 35.3068 14.4958 35.3044 15.1491C35.2832 20.439 35.2821 25.7288 35.3044 31.0187C35.308 31.699 35.0631 32.084 34.4828 32.4159C29.8627 35.0585 25.2556 37.7222 20.652 40.3942C20.1882 40.6638 19.8115 40.6579 19.3478 40.3895C14.7795 37.7364 10.2064 35.0891 5.61695 32.4724C4.95896 32.0969 4.67999 31.672 4.69411 30.8951C4.7412 28.2902 4.71177 25.6841 4.71177 23.078L4.71412 23.0792ZM6.29378 23.0521C6.29378 25.5005 6.30673 27.95 6.28201 30.3984C6.2773 30.848 6.40678 31.0987 6.80111 31.3247C11.0963 33.786 15.3809 36.2626 19.6632 38.7463C19.9175 38.8934 20.0929 38.8982 20.3471 38.751C24.5941 36.2862 28.8457 33.8272 33.1056 31.3848C33.5411 31.1352 33.7318 30.8786 33.7295 30.3419C33.7024 25.484 33.7083 20.6249 33.7236 15.7671C33.7248 15.3433 33.6071 15.0985 33.2339 14.8843C28.9234 12.4112 24.6211 9.92399 20.3224 7.4309C20.0858 7.29318 19.9281 7.29672 19.6915 7.43326C15.3927 9.92634 11.0893 12.4112 6.77875 14.8843C6.41032 15.0961 6.27848 15.3351 6.28201 15.7636C6.30438 18.1919 6.29261 20.6214 6.29261 23.0509L6.29378 23.0521Z",
    fill: "url(#paint0_linear_908_177)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3381 24.1868C14.3381 22.5235 14.331 20.9168 14.3416 19.3112C14.3451 18.698 14.7348 18.3319 15.2456 18.4378C15.6623 18.5249 15.8918 18.798 15.893 19.2265C15.8965 21.8126 15.8965 24.3998 15.893 26.9859C15.893 27.3626 15.7011 27.6168 15.3433 27.7286C14.9231 27.8605 14.6229 27.6827 14.3969 27.3367C13.3681 25.7641 12.3382 24.1915 11.3094 22.6189C11.1835 22.427 11.0552 22.2387 10.9186 22.0339C10.7303 22.1987 10.8115 22.3846 10.8103 22.5424C10.8021 23.9337 10.8103 25.325 10.8044 26.7163C10.8021 27.4191 10.5043 27.7946 9.98753 27.7734C9.49551 27.7534 9.213 27.3838 9.213 26.7258C9.20947 24.2962 9.213 21.8667 9.20947 19.4372C9.20947 18.9899 9.31306 18.6109 9.7886 18.4637C10.27 18.3142 10.5561 18.5826 10.8009 18.9581C11.8356 20.5507 12.8773 22.1386 13.9226 23.7242C14.0238 23.8772 14.0697 24.0867 14.3392 24.1879L14.3381 24.1868Z",
    fill: "url(#paint1_linear_908_177)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4339 23.105C17.4339 21.9102 17.4315 20.7143 17.4339 19.5195C17.4362 18.6838 17.6928 18.4166 18.5097 18.4131C19.6456 18.4072 20.7815 18.406 21.9174 18.4131C22.5731 18.4178 22.9332 18.7191 22.9179 19.2241C22.9026 19.7067 22.553 19.9974 21.9374 20.0045C21.1146 20.0139 20.2919 20.0269 19.4702 19.9986C19.0971 19.9857 18.9888 20.1057 19.0218 20.4624C19.0771 21.0592 18.7699 21.8596 19.1477 22.1998C19.4773 22.4964 20.2624 22.2892 20.8463 22.2987C21.2382 22.3045 21.6302 22.2869 22.021 22.3034C22.586 22.3281 22.9238 22.6412 22.9168 23.1061C22.9109 23.5699 22.5719 23.8795 22.001 23.8901C21.1394 23.9066 20.2777 23.9066 19.4161 23.8889C19.1089 23.8818 19.0112 23.9713 19.0194 24.2832C19.0394 25.106 19.0324 25.9288 19.0241 26.7516C19.0182 27.4202 18.7322 27.778 18.2308 27.7733C17.7329 27.7686 17.4362 27.3978 17.4339 26.7492C17.428 25.5345 17.4327 24.3197 17.4327 23.105H17.4339Z",
    fill: "url(#paint2_linear_908_177)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2555 18.4107C28.0959 18.4107 28.9376 18.4048 29.778 18.4131C30.4148 18.419 30.8044 18.7427 30.7856 19.2265C30.7668 19.6879 30.3842 19.9939 29.7921 20.0057C29.3425 20.0151 28.8905 20.0328 28.4432 19.9998C28.0642 19.9727 27.9935 20.1222 27.9959 20.4695C28.0112 22.5823 28.0065 24.6952 28.0018 26.8081C28.0006 27.4696 27.6345 27.8569 27.1072 27.758C26.5916 27.6627 26.4292 27.306 26.4304 26.814C26.4374 24.7988 26.4374 22.7836 26.4304 20.7684C26.428 19.888 26.5516 20.0198 25.6417 20.0069C25.3486 20.0022 25.0555 20.008 24.7612 20.0069C24.0514 19.9998 23.683 19.7338 23.6701 19.2206C23.6559 18.7015 24.0232 18.4166 24.7306 18.4131C25.5711 18.4084 26.4127 18.4131 27.2531 18.4131L27.2555 18.4107Z",
    fill: "url(#paint3_linear_908_177)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46.1892L0 34.6419V11.5473L20 0L40 11.5473V34.6419L20 46.1892ZM1.41251 33.8261L20 44.5577L38.5875 33.8261V12.363L20 1.63145L1.41251 12.363V33.8261Z",
    fill: "url(#paint4_linear_908_177)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_177",
    x1: 3.62675,
    y1: -79.4083,
    x2: -9.99906,
    y2: -77.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_177",
    x1: 8.97644,
    y1: -4.29846,
    x2: 5.98701,
    y2: -4.01475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_177",
    x1: 17.2397,
    y1: -4.33572,
    x2: 14.779,
    y2: -4.14427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_177",
    x1: 23.4216,
    y1: -4.334,
    x2: 20.2435,
    y2: -4.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_908_177",
    x1: -1.39409,
    y1: -112.173,
    x2: -19.2039,
    y2: -110.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.f631a7394e69e4e6d999f27b32899cd6.svg";
export { ForwardRef as ReactComponent };